module.exports = __webpack_public_path__ + "img/uprock_opac.6e96a45b.svg";